// extracted by mini-css-extract-plugin
export default {"component":"header_component__3fveQ","container":"header_container__h4hkr"};